import { TWELVE_WEEK_SHORTLIST } from '@infrastructure/routing/constants';
import camelize from 'camelize';
import { isEmpty } from '../core';

// Fields to send in the mutation object when submiting the form
const ACCEPTED_MUTATION_FIELDS = [
  'business_email',
  'business_phone_number',
  'career_level_id',
  'company_id',
  'company_name',
  'company_notes',
  'course_of_study',
  'currency_code',
  'degree',
  'discipline_id',
  'industry_id',
  'job_description',
  'job_location_city',
  'job_location_id',
  'job_post_code',
  'jobrole_id',
  'job_title',
  'job_type',
  'leadership_responsibility',
  'linked_record_id',
  'linked_record_source',
  'linked_record_type',
  'previous_jobrole_id',
  'previous_position',
  'product_type',
  'scrambled_reference_profile_id',
  'required_languages',
  'required_skills',
  'salary_range',
  'scrambled_company_id',
  'work_experience_id',
  'position_country_code',
  'position_location_cities',
  'position_location_coordinates',
  'position_location_ids',
  'full_remote',
  'position_radius',
];

const validateValue = (prop, values) => {
  if (prop === 'required_skills') {
    return ensureUniqueSkills(prop, values);
  }

  return values[prop];
};

const ensureUniqueSkills = (prop, values) => {
  const rawSkills = values[prop];
  const lowcaseSkills = rawSkills.map((skill) => skill.toLowerCase());

  return rawSkills.filter(
    (skill, index) => lowcaseSkills.indexOf(skill.toLowerCase()) === index,
  );
};

export const renameScrambledFields = (values) => {
  const prefix = 'scrambled_';

  return Object.keys(values).reduce((descrambled_field_names, fieldName) => {
    if (fieldName.startsWith('scrambled')) {
      descrambled_field_names[fieldName.substring(prefix.length)] =
        values[fieldName];
    } else {
      descrambled_field_names[fieldName] = values[fieldName];
    }

    return descrambled_field_names;
  }, {});
};

export const inputValuesForMutation = (values, duration?: number) => {
  let body = {};

  for (const prop in values) {
    if (!ACCEPTED_MUTATION_FIELDS.includes(prop)) continue;
    if (isEmpty(values[prop])) continue;
    const validatedValue = validateValue(prop, values);

    body = { ...body, [prop]: validatedValue };
  }

  const jobLocation = values.job_location;
  body = { ...body, job_location_city: jobLocation };

  if (duration && duration === parseInt(TWELVE_WEEK_SHORTLIST, 10)) {
    body = { ...body, duration };
  }

  return camelize(renameScrambledFields(body));
};
